import { jsx, jsxs } from "react/jsx-runtime";
const IconHome = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2.09998L1 12H4V21H11V15H13V21H20V12H23L12 2.09998ZM18 19H15V13H9V19H6V10.19L12 4.68998L18 10.19V19Z",
        fill: "currentColor"
      }
    )
  }
);
const IconSidebar = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "16",
    viewBox: "0 0 19 16",
    fill: "none",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M0 12.8571C0 13.6907 0.331121 14.4901 0.920521 15.0795C1.50992 15.6689 2.30932 16 3.14286 16H15.3571C16.1907 16 16.9901 15.6689 17.5795 15.0795C18.1689 14.4901 18.5 13.6907 18.5 12.8571V3.14286C18.5 2.30932 18.1689 1.50992 17.5795 0.920521C16.9901 0.331121 16.1907 0 15.3571 0H3.14286C2.30932 0 1.50992 0.331121 0.920521 0.920521C0.331121 1.50992 0 2.30932 0 3.14286V12.8571ZM16.7857 3.14286V12.8571C16.7857 13.236 16.6352 13.5994 16.3673 13.8673C16.0994 14.1352 15.736 14.2857 15.3571 14.2857H6.28571V1.71429H15.3571C15.736 1.71429 16.0994 1.8648 16.3673 2.1327C16.6352 2.40061 16.7857 2.76398 16.7857 3.14286ZM1.71429 3.14286C1.71429 2.76398 1.8648 2.40061 2.1327 2.1327C2.40061 1.8648 2.76398 1.71429 3.14286 1.71429H4.57143V14.2857H3.14286C2.76398 14.2857 2.40061 14.1352 2.1327 13.8673C1.8648 13.5994 1.71429 13.236 1.71429 12.8571V3.14286Z",
        fill: "currentColor"
      }
    )
  }
);
const IconCompose = ({ size = 18, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.07434 18C4.65475 17.9995 4.24889 17.8505 3.92866 17.5794C3.60843 17.3083 3.39452 16.9325 3.32484 16.5188L3.03015 14.7472C2.4833 14.4569 1.99033 14.0749 1.57274 13.6178C-0.524245 11.1924 -0.524245 4.75952 1.57274 2.33453C2.83672 0.872802 5.55942 0 8.85548 0H8.85637C12.152 0 14.8743 0.872802 16.1378 2.33455C18.2348 4.75954 18.2348 11.1924 16.1378 13.6174C14.8972 15.0532 12.2191 15.923 8.97451 15.9437C8.79813 15.9422 8.62514 15.9923 8.47687 16.0878L6.05662 17.7014C5.7659 17.8959 5.42408 17.9998 5.07434 18ZM8.85548 1.77244C6.19163 1.77244 3.80385 2.46393 2.91331 3.49381C1.39228 5.25284 1.39228 10.6991 2.91331 12.4586C3.18409 12.7484 3.50536 12.9865 3.86141 13.1613C4.10285 13.2928 4.311 13.4778 4.46993 13.7022C4.62886 13.9265 4.73436 14.1842 4.77835 14.4556L5.07304 16.2272L7.49413 14.6127C7.93001 14.3255 8.44038 14.1721 8.96237 14.1713C11.6228 14.154 13.9123 13.482 14.7972 12.4586C16.3183 10.6992 16.3183 5.2529 14.7972 3.49343C13.9071 2.46436 11.5198 1.77244 8.85637 1.77244H8.85548Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.85549 11.5209C8.62045 11.5209 8.39503 11.4275 8.22883 11.2613C8.06264 11.0951 7.96927 10.8697 7.96927 10.6346V5.31732C7.96927 5.08228 8.06264 4.85686 8.22883 4.69066C8.39503 4.52447 8.62045 4.4311 8.85549 4.4311C9.09053 4.4311 9.31594 4.52447 9.48214 4.69066C9.64834 4.85686 9.7417 5.08228 9.7417 5.31732V10.6346C9.7417 10.8697 9.64834 11.0951 9.48214 11.2613C9.31594 11.4275 9.09053 11.5209 8.85549 11.5209Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.5141 8.86219H6.19683C5.96179 8.86219 5.73637 8.76882 5.57018 8.60262C5.40398 8.43643 5.31061 8.21101 5.31061 7.97597C5.31061 7.74093 5.40398 7.51552 5.57018 7.34932C5.73637 7.18312 5.96179 7.08975 6.19683 7.08975H11.5141C11.7492 7.08975 11.9746 7.18312 12.1408 7.34932C12.307 7.51552 12.4004 7.74093 12.4004 7.97597C12.4004 8.21101 12.307 8.43643 12.1408 8.60262C11.9746 8.76882 11.7492 8.86219 11.5141 8.86219Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconImageUpload = ({ size = 24, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.342 23.9893H8.64729C2.58861 23.9893 0 21.4007 0 15.342V8.64729C0 2.58861 2.58861 0 8.64729 0H15.342C21.4007 0 23.9893 2.58861 23.9893 8.64729V15.342C23.9893 21.4007 21.4007 23.9893 15.342 23.9893ZM8.64729 1.67367C3.50355 1.67367 1.67367 3.50355 1.67367 8.64729V15.342C1.67367 20.4857 3.50355 22.3156 8.64729 22.3156H15.342C20.4857 22.3156 22.3156 20.4857 22.3156 15.342V8.64729C22.3156 3.50355 20.4857 1.67367 15.342 1.67367H8.64729Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.64728 10.5999C6.9513 10.5999 5.57889 9.2275 5.57889 7.53151C5.57889 5.83553 6.9513 4.46312 8.64728 4.46312C10.3433 4.46312 11.7157 5.83553 11.7157 7.53151C11.7157 9.2275 10.3433 10.5999 8.64728 10.5999ZM8.64728 6.13679C7.8774 6.13679 7.25256 6.76162 7.25256 7.53151C7.25256 8.3014 7.8774 8.92624 8.64728 8.92624C9.41717 8.92624 10.042 8.3014 10.042 7.53151C10.042 6.76162 9.41717 6.13679 8.64728 6.13679Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.58414 20.5863C1.31636 20.5863 1.04857 20.4524 0.892361 20.218C0.635731 19.8387 0.736151 19.3143 1.12667 19.0576L6.62747 15.3644C7.83251 14.5499 9.49502 14.6503 10.5885 15.5764L10.9567 15.9C11.5146 16.3798 12.463 16.3798 13.0098 15.9L17.6514 11.9166C18.8341 10.9013 20.6975 10.9013 21.8914 11.9166L23.7101 13.4787C24.056 13.78 24.1006 14.3044 23.7994 14.6615C23.4981 15.0074 22.9737 15.052 22.6166 14.7507L20.7979 13.1886C20.24 12.7088 19.2916 12.7088 18.7337 13.1886L14.0921 17.172C12.9093 18.1873 11.046 18.1873 9.85211 17.172L9.48387 16.8484C8.97061 16.4132 8.12261 16.3686 7.55357 16.7591L2.05277 20.4524C1.90772 20.5416 1.74035 20.5863 1.58414 20.5863Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const IconMicrophone = ({
  size = 17,
  height = 24,
  className,
  style
}) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.5 17.1429C5.68778 17.1429 3.4 14.8359 3.4 12V5.14286C3.4 2.307 5.68778 0 8.5 0C11.3122 0 13.6 2.307 13.6 5.14286V12C13.6 14.8359 11.3122 17.1429 8.5 17.1429ZM8.5 1.71429C6.62533 1.71429 5.1 3.25243 5.1 5.14286V12C5.1 13.8904 6.62533 15.4286 8.5 15.4286C10.3747 15.4286 11.9 13.8904 11.9 12V5.14286C11.9 3.25243 10.3747 1.71429 8.5 1.71429ZM16.15 10.2857C15.6806 10.2857 15.3 10.6695 15.3 11.1429V12C15.3 15.7811 12.2496 18.8571 8.5 18.8571C4.75044 18.8571 1.7 15.7811 1.7 12V11.1429C1.7 10.6695 1.31941 10.2857 0.85 10.2857C0.380587 10.2857 0 10.6695 0 11.1429V12C0 16.4372 3.36069 20.0966 7.65 20.5279V22.2857H5.95C5.48059 22.2857 5.1 22.6695 5.1 23.1429C5.1 23.6162 5.48059 24 5.95 24H11.05C11.5194 24 11.9 23.6162 11.9 23.1429C11.9 22.6695 11.5194 22.2857 11.05 22.2857H9.35V20.5279C13.6393 20.0964 17 16.437 17 12V11.1429C17 10.6695 16.6194 10.2857 16.15 10.2857Z",
        fill: "currentColor"
      }
    )
  }
);
const IconArrowRight = ({ size = 12, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size * 9 / 12,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.1231 4.03711C11.1229 4.03695 11.1228 4.03675 11.1226 4.03659L8.22563 1.16103C8.0086 0.945614 7.65757 0.946414 7.44154 1.1629C7.22553 1.37938 7.22637 1.72952 7.44339 1.94495L9.38841 3.87559H1.55442C1.24822 3.87559 1 4.12315 1 4.42858C1 4.734 1.24822 4.98161 1.55442 4.98161H9.38839L7.44344 6.9122C7.22641 7.12765 7.22557 7.47776 7.44158 7.69423C7.6576 7.91075 8.00867 7.91151 8.22567 7.69612L11.1226 4.82053C11.1228 4.82037 11.1229 4.82017 11.1231 4.82C11.3403 4.60386 11.3396 4.25257 11.1231 4.03712L11.1231 4.03711Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.428571"
      }
    )
  }
);
const IconHamburger = ({ size = 32, className, style }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 10h12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 16h20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ jsx("path", { d: "M6 22h16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const IconClose = ({ size = 20, className, style }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style,
    children: /* @__PURE__ */ jsx("path", { d: "M15.5 4.5L4.5 15.5M4.5 4.5l11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  }
);
export {
  IconArrowRight,
  IconClose,
  IconCompose,
  IconHamburger,
  IconHome,
  IconImageUpload,
  IconMicrophone,
  IconSidebar
};
//# sourceMappingURL=ConciergeIcons.js.map
